import { render, staticRenderFns } from "./ModalComment.vue?vue&type=template&id=17449742&scoped=true"
import script from "./ModalComment.vue?vue&type=script&lang=js"
export * from "./ModalComment.vue?vue&type=script&lang=js"
import style0 from "./ModalComment.vue?vue&type=style&index=0&id=17449742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17449742",
  null
  
)

export default component.exports